import { CTAButton } from 'component/button';
import { getIsInPsiNativeAppWebview } from 'platform-specific/url';
import { useDatastore, useIsAdminUi } from 'util/datastore';
import { t } from 'util/stdtypes';
import { requestAppLogin } from 'util/webview';

import { HttpError } from './http-error';

export function Unauthorized() {
    const datastore = useDatastore();
    const isAdminUi = useIsAdminUi();

    function onLogin() {
        if (getIsInPsiNativeAppWebview()) {
            requestAppLogin();
        } else {
            datastore.gotoInstance({ structureKey: 'login', instanceKey: 'one', params: { action: isAdminUi ? 'admin' : undefined } });
        }
    }

    return (
        <HttpError
            code='401'
            cta={<CTAButton label={t('user_info.log_in_button', 'Log in')} onPress={onLogin} size='small' />}
            label={t('appError.page_unauthorized', 'You don’t have permission to access this page.')}
        />
    );
}
